import { BaseService } from "./baseService";
import httpRequest from ".";
import type { Page, CustomerFavoriteFollowVo } from "@zhihaoscm/entity";

export class CustomerFavoriteFollowService extends BaseService<unknown, unknown, any, any> {
    // 取消收藏-关注
    public async deleteById(id: number): Promise<any> {
        const { data } = await this.service.delete(`${this.path}/${id}`);

        return data;
    }

    // 批量取消收藏-关注
    public async batchDelete(ids: number[]): Promise<any> {
        const { data } = await this.service.delete(`${this.path}/batch/delete`, {
            data: ids
        });

        return data;
    }

    // 清空收藏-关注
    public async clear(type: number): Promise<void> {
        const { data } = await this.service.delete(`${this.path}/clear?type=${type}`);

        return data;
    }

    // 分页查询
    public async customPaging(params: {
        type: number;
        page?: number;
        size?: number;
        keyword?: string;
        onlyHasStock?: boolean;
    }): Promise<Page<CustomerFavoriteFollowVo>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, {
            params
        });

        return data;
    }
}

export const customerFavoriteFollowService = new CustomerFavoriteFollowService(
    "/customer-favorite-follow",
    httpRequest
);
